import { createBrowserHistory } from 'history'

// Keep imperative navigation in one place so callers
// can remain framework-agnostic.
const history = createBrowserHistory()

export const navigateTo = (path) => history.push(path)

export const replaceTo = (path) => history.replace(path)

export const getCurrentPath = () => history?.location?.pathname || ''

export const goBack = () => history.go(-1)

export default history
